import * as _ from 'lodash';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { DOC_TEMPLATES } from './constant';

@Injectable()
export class TemplateService {
  documentTemplates = DOC_TEMPLATES;

  constructor(private apiService: ApiService) {
  }

  get() {
    return this.documentTemplates;
  }

  getTemplate(type) {
    var template: any;
    _.forEach(this.documentTemplates, (obj) => {
      if (obj.type == type) {
        template = obj;
      }
    })
    return template;
  }

  getName(type) {
    let template = this.getTemplate(type)
    if (template == null)
      return null;
    else
      return template.name;
  }

  getNameEN(type) {
    let template = this.getTemplate(type)
    if (template == null)
      return null;
    else
      return template.nameEN;
  }

  getFullName(type) {
    var template = this.getTemplate(type);
    if (template == null)
      return null;

    return template.name + ' ('  + template.nameEN + ')';
  }

  getDropdown() {
    var type = [{
      label: 'ทั้งหมด',
      value: null
    }];
    _.forEach(this.documentTemplates, (obj) => {
      type.push({
        label: obj.name + ' (' + obj.nameEN + ')',
        value: obj.type
      });
    });
    return type;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/services/template.service.ts